import { useQuery } from '@tanstack/react-query';
import { getPharmDashboardService } from '../../../domains/pharmDashboard';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

// 홈 '진행중인 이벤트' — 약국 토큰 기준 (brn은 로그인 여부 게이트로만 사용)
export const useActiveEvents = (brn: string | null | undefined) => {
  return useQuery({
    queryKey: ['active-events', brn],
    enabled: !!brn,
    queryFn: async () => {
      const res = await getPharmDashboardService().getActiveEvents();
      if (!isResultOk(res)) return null;
      return res?.data ?? null;
    },
  });
};
